import React from 'react';
import { Link } from 'react-router-dom';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const PriceToCostCenterButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="raised"
    component={Link}
    to={`/prices/create?costId=${record.id}`}
    label="Añadir un precio"
    title="Añadir un precio"
  >
    <MonetizationOnIcon />
  </Button>
);

export default withStyles(styles)(PriceToCostCenterButton);
